module.exports = __webpack_public_path__ + "static/media/img3.1ce7f1b0.jpg";